// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__2Mk4D","title":"style_title__2Z4r7","time":"style_time__12gA5","content":"style_content__1ugJf","tabs":"style_tabs__1Ff-l"};